module.exports = __webpack_public_path__ + "static/newmug1-f421e9d2c6d277ee7834d1bcc2bb3da5.png";